export const MODEL_ONBOARDING_INTENTS = ['SOLO', 'COUPLE', 'GROUP', 'JOIN_ACT'];
export const MODEL_ONBOARDING_STATUSES = [
    'DRAFT',
    'MISSING_DATA',
    'IN_REVIEW',
    'APPROVED',
    'REJECTED',
];
/** Persisted default for existing / seed models so they are not blocked. */
export const DEFAULT_MODEL_ONBOARDING_STATUS = 'APPROVED';
export const MODEL_ONBOARDING_STEPS = [
    'intent',
    'qualify',
    'act',
    'profile',
    'review',
];
export const MODEL_ONBOARDING_CHECKLIST_KEYS = [
    'account',
    'intent',
    'identity',
    'idDocument',
    'selfie',
    'signature',
    'profile',
    'review',
];
export const MODEL_ONBOARDING_CHECKLIST_STATUSES = ['ok', 'missing', 'rejected'];
export const MODEL_PARTNER_INVITE_MODES = ['TOGETHER', 'LATER'];
export function isModelOnboardingIntent(value) {
    return (typeof value === 'string' &&
        MODEL_ONBOARDING_INTENTS.includes(value));
}
export function parseModelOnboardingIntent(value) {
    return isModelOnboardingIntent(value) ? value : 'SOLO';
}
export function isModelOnboardingStatus(value) {
    return (typeof value === 'string' &&
        MODEL_ONBOARDING_STATUSES.includes(value));
}
export function parseModelOnboardingStatus(value) {
    return isModelOnboardingStatus(value) ? value : DEFAULT_MODEL_ONBOARDING_STATUS;
}
export function isModelOnboardingStep(value) {
    return (typeof value === 'string' && MODEL_ONBOARDING_STEPS.includes(value));
}
export function parseModelOnboardingStep(value) {
    return isModelOnboardingStep(value) ? value : 'intent';
}
export function isModelPartnerInviteMode(value) {
    return (typeof value === 'string' &&
        MODEL_PARTNER_INVITE_MODES.includes(value));
}
export function parseModelPartnerInviteMode(value) {
    return isModelPartnerInviteMode(value) ? value : null;
}
export function canBroadcastOnboarding(status) {
    return parseModelOnboardingStatus(status) === 'APPROVED';
}
export function emptyModelOnboardingState() {
    return {
        hasProfile: false,
        canBroadcast: false,
        step: 'intent',
        status: 'DRAFT',
        intent: 'SOLO',
        legalName: null,
        legalFirstName: null,
        legalMiddleName: null,
        legalLastName: null,
        dateOfBirth: null,
        aliases: null,
        idDocumentUrl: null,
        idDocumentBackUrl: null,
        selfieWithIdUrl: null,
        identityVendorId: null,
        identityVendorRef: null,
        identityVerifiedAt: null,
        signatureName: null,
        agreementSignedAt: null,
        taxAttestedAt: null,
        actHandleDraft: null,
        partnerInviteMode: null,
        joinActCode: null,
        rejectionReason: null,
        displayName: null,
        gender: null,
        avatarUrl: null,
        checklist: [
            { key: 'account', status: 'ok' },
            { key: 'intent', status: 'missing' },
            { key: 'identity', status: 'missing' },
            { key: 'idDocument', status: 'missing' },
            { key: 'selfie', status: 'missing' },
            { key: 'signature', status: 'missing' },
            { key: 'profile', status: 'missing' },
            { key: 'review', status: 'missing' },
        ],
    };
}
//# sourceMappingURL=model-onboarding.js.map